import React from 'react';
import { Text } from '../../../../../../../../../../../../../../CommonComponents/OPL/Text/Text';
import { formatCurrency } from '../../../../../../../../../../../../../../CommonUtils/formatNumber';

interface Props {
  value: number | null;
}

export const Value = ({ value }: Props) => {
  if (value === null) {
    return <Text css="font-size: 30px">-</Text>;
  }

  return <>{formatCurrency(value)}</>;
};
